import { z } from "zod";
import { ZDate } from "./ZDate.js";
import { zArr, zNullable, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
import { Interval } from "./common.js";
export var CBMResponseInterval;
(function (CBMResponseInterval) {
    CBMResponseInterval["DAY"] = "day";
    CBMResponseInterval["MONTH"] = "month";
    CBMResponseInterval["YEAR"] = "year";
})(CBMResponseInterval || (CBMResponseInterval = {}));
export const CBMResponseIntervalEnum = z.nativeEnum(CBMResponseInterval);
export var CBMComponentType;
(function (CBMComponentType) {
    CBMComponentType["MAINENGINE"] = "main engine";
    CBMComponentType["THRUSTER"] = "thruster";
})(CBMComponentType || (CBMComponentType = {}));
export const CBMComponentTypeEnum = z.nativeEnum(CBMComponentType);
export var CBMSubGroupType;
(function (CBMSubGroupType) {
    CBMSubGroupType["MAINPROPULSION"] = "main propulsion";
    CBMSubGroupType["AUXILIARYPROPULSION"] = "auxiliary propulsion";
})(CBMSubGroupType || (CBMSubGroupType = {}));
export const CBMSubGroupTypeEnum = z.nativeEnum(CBMSubGroupType);
export const CBMGetComponentsMetadataArgs = z.object({
    plantId: zNum(),
});
export const CBMComponentMetadata = z.object({
    componentId: zStr(),
    label: zStr(),
    type: CBMComponentTypeEnum,
    subGroup: zOptional(CBMSubGroupTypeEnum),
    maxPower: zOptional(zNum()),
});
export const CBMGetAvailablePerformanceParametersArgs = z.object({
    plantId: zNum(),
    componentType: CBMComponentTypeEnum,
});
export const CBMPerformanceParameterMetadata = z.object({
    id: zNum(),
    name: zStr(),
    unit: zStr(),
});
export const CBMGetPowerUtilizationArgs = z.object({
    plantId: zNum(),
    interval: Interval,
    loadRangePercentage: zObj({
        min: zNum(),
        max: zNum(),
    }),
    responseInterval: CBMResponseIntervalEnum,
    opModeId: zOptional(zArr(zNullable(zNum()))),
});
export const CBMComponentUtilizationData = z.object({
    data: zArr(z.object({
        timestamp: ZDate,
        avgPowerkW: zNum(),
    })),
    componentId: zStr(),
});
export const CBMPowerUtilizationData = z.object({
    utilizationData: zArr(CBMComponentUtilizationData),
    avgUnitsInUse: zArr(z.object({
        componentType: CBMComponentTypeEnum,
        units: zNum(),
    })),
});
export const CBMGetAvgLoadAndPerformanceDeviationPlotDataArgs = z.object({
    plantId: zNum(),
    interval: Interval,
    loadRangePercentage: zObj({
        min: zNum(),
        max: zNum(),
    }),
    responseInterval: CBMResponseIntervalEnum,
    performanceParameterId: zOptional(zNum()),
    componentsId: zArr(zStr()),
    // componentType: CBMComponentTypeEnum,
    opModesId: zOptional(zArr(zNullable(zNum()))),
});
export const CBMComponentAvgLoadAndPerformanceDeviationData = zArr(z.object({
    timestamp: ZDate,
    performanceParamenterDeviationPercentage: zOptional(zNum()),
    avgLoadPercentage: zNum(),
}));
export const CBMAvgLoadAndPerformanceDeviationPlotData = z.object({
    data: CBMComponentAvgLoadAndPerformanceDeviationData,
});
export const CBM2PercentageTimeInLoadThresholdedDataArgs = z.object({
    // componentType: CBMComponentTypeEnum,
    plantId: zNum(),
    componentsId: zArr(zStr()),
    thresholdPercentage: zNum(),
    opModeIds: zOptional(zArr(zNullable(zNum()))),
    interval: Interval,
});
export const CBM2PercentageTimeInLoadThresholdedDataEntry = z.object({
    componentId: zStr(),
    percentageTimeAboveThreshold: zNum(),
});
export const CBMGetComponentsOperationDataArgs = z.object({
    componentType: CBMComponentTypeEnum,
    plantId: zNum(),
    interval: Interval,
    opModeId: zArr(zNum()),
});
export const CBMComponentDataState = z.object({
    dateLastOverhaul: ZDate,
    runningHours: zNum(),
    lastOverhaulHours: zNum(),
    nextOverhaulHours: zNum(),
    estimatedDateNextOverhaul: ZDate,
});
export const CBMComponentOperationData = z.object({
    componentId: zStr(),
    state: zNullable(CBMComponentDataState),
    runningHours: zNum(),
    averageLoadPercent: zNum(),
});
export const CBMSetComponentParamsArgs = z.object({
    // componentType: CBMComponentTypeEnum,
    plantId: zNum(),
    componentId: zStr(),
    lastOverhaulDate: ZDate,
    lastOverhaulHours: zNum(),
    nextOverhaulHours: zNum(),
    currentRunningHours: zNum(),
    currentDate: ZDate,
});
export const CBMGetLoadDistributionPlotDataArgs = z.object({
    // componentType: CBMComponentTypeEnum,
    plantId: zNum(),
    componentId: zArr(zStr()),
    interval: Interval,
    performanceParameterId: zOptional(zNum()),
    opModeId: zOptional(zArr(zNullable(zNum()))),
});
export const CombinedLoadProfiles = z.array(z.object({
    componentIds: z.array(zStr()),
    loadProfile: z.array(z.object({
        loadPercentage: zNum(),
        percentageTimeInLoad: zNum(),
    })),
}));
export const CombinedAverageLoad = z.array(z.object({
    componentIds: z.array(zStr()),
    averageLoad: z.array(z.object({
        timestamp: ZDate,
        avgLoadPercentage: zNum(),
    })),
}));
export const CBM2LoadDistributionPlotEntry = z.object({
    loadPercentage: zNum(),
    percentageTimeInLoad: zNum(),
    performanceParameterMeasured: zNullable(zNum()),
    performanceParameterBaselined: zNullable(zNum()),
});
//# sourceMappingURL=conditionbasedmaintenance2.js.map